import s from './month-calendar.module.scss';
import classNames from 'classnames';
import { getDate, isSameDay, isSameMonth, isToday } from 'date-fns';
import { formatDateKey, WEEK_DAY_NAMES } from '../../lib/date';

export const MonthCalendar = ({
  days,
  selectedDate,
  currentMonth,
  appointmentsByDay,
  timezone,
  onSelectDay,
}) => (
  <div className={s.monthCalendar}>
    <div className={s.weekDaysHeader}>
      {WEEK_DAY_NAMES.map((name) => (
        <div key={name} className={s.weekDayLabel}>
          {name}
        </div>
      ))}
    </div>
    <div className={s.monthDaysGrid}>
      {days.map((date) => {
        const key = formatDateKey(date, timezone);
        const isSelected = isSameDay(date, selectedDate);
        const isCurrentMonth = isSameMonth(date, currentMonth);
        const isTodayDate = isToday(date);
        const count = (appointmentsByDay[key] || []).length;

        return (
          <button
            key={date.toISOString()}
            className={classNames(
              s.monthDay,
              !isCurrentMonth && s.otherMonth,
              isSelected && s.selected,
              isTodayDate && !isSelected && s.today
            )}
            onClick={() => onSelectDay(date)}
            type="button"
          >
            <span className={s.dayNumber}>{getDate(date)}</span>
            {count > 0 && <span className={s.dayDot} />}
          </button>
        );
      })}
    </div>
  </div>
);
